import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div className='spinner-container'>
      <div className='spinner'></div>
      <div className='loader-label-loading'>Loading...</div>
    </div>
  );
};

export default Loader;
